import { api as initApi } from '@anna/anna-ws-server-library';

const getConfig = ({ publicApiUrl }) => ({
  publicApi: publicApiUrl,
});

const api = {};

export const init = (apiConfig) => {
  const config = getConfig(apiConfig);
  const newApi = initApi(config, apiConfig.token);

  if (process.env.NODE_ENV === 'development') {
    const originalFetch = newApi.publicApi.fetch;
    const originalFetchFile = newApi.publicApi.fetchFile;

    newApi.publicApi.fetch = (method, url, params) => originalFetch(method, url, params, {
      withCredentials: true,
    });
    newApi.publicApi.fetchFile = (url) => originalFetchFile(url, {
      withCredentials: true,
    });
  }

  Object.assign(api, newApi);
};

export default api;
